var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1446 43.9108H41.5196C44.728 43.9108 46.728 40.4316 45.1238 37.6608L29.4363 10.5566C27.8321 7.78581 23.8321 7.78581 22.228 10.5566L6.54045 37.6608C4.93629 40.4316 6.93629 43.9108 10.1446 43.9108ZM25.8321 29.3275C24.6863 29.3275 23.7488 28.39 23.7488 27.2441V23.0775C23.7488 21.9316 24.6863 20.9941 25.8321 20.9941C26.978 20.9941 27.9155 21.9316 27.9155 23.0775V27.2441C27.9155 28.39 26.978 29.3275 25.8321 29.3275ZM27.9155 37.6608H23.7488V33.4941H27.9155V37.6608Z",
    fill: "#FF9D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a31f1c29bc3bd4f0606a680829b49e75.svg";
export { ForwardRef as ReactComponent };